import { useEffect } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { setVisitedSubunitsAction } from '../state/actions';

const VisibleUnitsWrapper = (props) => {
  const {
    visitedSubunits,
    subjectId,
    userId,
    unitNumber,
    subunits,
    setVisitedSubunits,
    subunitRefs,
    isStudent,
  } = props;

  useEffect(() => {
    //setting defaults to redux
    const currentVisitedSubunits = get(
      visitedSubunits,
      [`${subjectId}-${userId}`, unitNumber],
      {},
    );
    if (isEmpty(currentVisitedSubunits) && unitNumber === '1') {
      setVisitedSubunits({
        subjectId,
        userId,
        unitNumber,
        number: '1',
        isVisited: true,
      });
    } else {
      const firstVisited = subunits.find(
        ({ number }) => currentVisitedSubunits[number],
      );
      if (
        !isStudent &&
        firstVisited &&
        subunitRefs.current[firstVisited.number]
      ) {
        subunitRefs.current[firstVisited.number].scrollIntoView();
      }
    }
  }, [unitNumber]);

  return null;
};

VisibleUnitsWrapper.propTypes = {};

const mapStateToProps = ({ visitedSubunits }) => ({
  visitedSubunits,
});

export default connect(mapStateToProps, {
  setVisitedSubunits: setVisitedSubunitsAction,
})(VisibleUnitsWrapper);
